const faSmall: Readonly<Record<string, number>> = {
  صفر: 0, یک: 1, يه: 1, دو: 2, سه: 3, چهار: 4, پنج: 5, شش: 6, هفت: 7, هشت: 8, نه: 9,
  ده: 10, یازده: 11, دوازده: 12, سیزده: 13, چهارده: 14, پانزده: 15, شانزده: 16,
  هفده: 17, هجده: 18, نوزده: 19, بیست: 20, سی: 30, چهل: 40, پنجاه: 50, شصت: 60,
  هفتاد: 70, هشتاد: 80, نود: 90, صد: 100, دویست: 200, سیصد: 300, چهارصد: 400,
  پانصد: 500, ششصد: 600, هفتصد: 700, هشتصد: 800, نهصد: 900,
};

const enSmall: Readonly<Record<string, number>> = {
  zero: 0, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9,
  ten: 10, eleven: 11, twelve: 12, thirteen: 13, fourteen: 14, fifteen: 15, sixteen: 16,
  seventeen: 17, eighteen: 18, nineteen: 19, twenty: 20, thirty: 30, forty: 40, fifty: 50,
  sixty: 60, seventy: 70, eighty: 80, ninety: 90,
};

const scales: Readonly<Record<string, number>> = {
  هزار: 1_000, میلیون: 1_000_000, میلیارد: 1_000_000_000,
  hundred: 100, thousand: 1_000, million: 1_000_000, billion: 1_000_000_000,
};

function parseWords(words: readonly string[]): number | undefined {
  let total = 0;
  let group = 0;
  let recognized = false;
  for (const word of words) {
    if (word === 'و' || word === 'and') continue;
    const small = faSmall[word] ?? enSmall[word];
    if (small !== undefined) {
      group += small;
      recognized = true;
      continue;
    }
    const scale = scales[word];
    if (scale === undefined) return undefined;
    recognized = true;
    if (scale === 100) group = Math.max(group, 1) * scale;
    else {
      total += Math.max(group, 1) * scale;
      group = 0;
    }
  }
  return recognized ? total + group : undefined;
}

function isNumberWord(word: string): boolean {
  return word === 'و' || word === 'and' || faSmall[word] !== undefined || enSmall[word] !== undefined || scales[word] !== undefined;
}

export function normalizeSpokenNumbers(value: string): string {
  const tokens = value.split(/\s+/u);
  const output: string[] = [];
  let index = 0;
  while (index < tokens.length) {
    if (!isNumberWord(tokens[index] ?? '')) {
      output.push(tokens[index] ?? '');
      index += 1;
      continue;
    }
    let end = index;
    while (end < tokens.length && isNumberWord(tokens[end] ?? '')) end += 1;
    const words = tokens.slice(index, end);
    while (words.at(-1) === 'و' || words.at(-1) === 'and') words.pop();
    const parsed = parseWords(words);
    if (parsed === undefined || words.length === 0) {
      output.push(tokens[index] ?? '');
      index += 1;
    } else {
      output.push(String(parsed));
      index += words.length;
    }
  }
  return output.join(' ');
}
